import { ExternalStyles } from 'bold-ui'
import React, { useState } from 'react'

import { LoteImunobiologicoModel } from '../model'
import LoteImunobiologicoEditInlineFormRow from './LoteImunobiologicoEditInlineFormRow'
import LoteImunobiologicoStaticRow from './LoteImunobiologicoStaticRow'

interface LoteImunobiologicoRowProps {
  row: LoteImunobiologicoModel
  editing: boolean
  onEditingChange(editing: boolean): void
  reload(): Promise<any>
  style?: ExternalStyles
}

export function LoteImunobiologicoRow(props: LoteImunobiologicoRowProps) {
  const { row, reload, editing, onEditingChange, style } = props

  const [fadeEffect, setFadeEffect] = useState(false)

  const handleEditClick = () => onEditingChange(true)

  const handleEditChange = () => {
    onEditingChange(false)
    setFadeEffect(true)
  }

  return editing ? (
    <LoteImunobiologicoEditInlineFormRow row={row} reload={reload} onEditChange={handleEditChange} />
  ) : (
    <LoteImunobiologicoStaticRow
      row={row}
      reload={reload}
      onEditClick={handleEditClick}
      style={fadeEffect ? style : null}
    />
  )
}
